import { v4 as uuidv4 } from 'uuid';
import { FC } from "react"
import { IdTableVariant, SearchOption } from "../../@types/enumsGlobal"
import GridSelectorInput from "../controls/GridSelectorInput"
import { IEntitySimpleDTO } from "../../libs/coreapi-dto/@types/common"
import { ILotDTO } from "../../libs/coreapi-dto/accounting/lot"
import { LotDataProvider } from "../../Services/DataProviders/LotDataProvider"
import { useAppContext } from "../../system/providers/appContextProvider"
import { LotsSelectorModal } from "../../Business/Accounting/Lots"
import { GridFilterAction } from "../../system/hooks/useGridFilter"
import { BarcodeType, IKizBoxDTO, IKizDTO } from "../../libs/coreapi-dto/dirs/kiz"
import { KizDataProvider } from "../../Services/DataProviders/KizDataProvider"
import buffer from 'buffer'
import { IKizOsuDTO } from '../../libs/coreapi-dto/dirs/KizOsu';
import { KizParsed } from '../../Business/Dictionaries/Kiz/KizParsed';


export type ISearchQueryInfo =
    {type: 'kiz', data: IKizDTO} |
    {type: 'kizBox', data: IKizBoxDTO} |
    {type: 'kizOsu', data: IKizOsuDTO}


interface ILotSelectorInputProps {
    disabled?: boolean
    barcodeScan?: boolean
    onlyLotRemain?: boolean
    searchOption?: SearchOption
    gridFilter?: IGridFilter
    dispatchGridFilter?: (value: GridFilterAction) => void
    onSelect?: (value: ILotDTO | ILotDTO[], searchQuery?: ISearchQueryInfo, decodedBarcode?: string) => void
    setScanData?: (value) => void
    documentIdTable?: IdTableVariant
    activateGroupProcessing?: boolean
    autoFocus?: boolean;
    lastSearchQuerySettings?: ILastSearchQuerySettings;
    key?: string
    idStoreGlobal?: string | null
}

const LotSelectorInput: FC<ILotSelectorInputProps> = (props) => {
    const appContext = useAppContext();
    const ldp = new LotDataProvider(appContext.coreApiService);
    const kdp = new KizDataProvider(appContext.coreApiService);

    const onSelectLot = (lot: IEntitySimpleDTO | IEntitySimpleDTO[], searchQuery?: string) => {
        if (!Array.isArray(lot) && lot) {
            ldp.getById(lot.idGlobal, (lot) => {
                let kizParsed = new KizParsed(searchQuery ?? '')
                if (kizParsed.isKiz ||
                    props.searchOption === SearchOption.kiz ||
                    props.searchOption === SearchOption.kizBox ||
                    props.searchOption === SearchOption.kizOrKizBox ||
                    props.searchOption === SearchOption.gtinSgtin)
                {                       
                    if (searchQuery) {                       
                        const barcode = buffer.Buffer.from(searchQuery, 'ascii').toString('base64')
                        const encodedBarcodeBase64 = encodeURIComponent(barcode);
                        kdp.parse(encodedBarcodeBase64, (parsedData) => {
                            switch(parsedData.barcodeType) {
                                case BarcodeType.Kiz: {
                                    const kizData = parsedData.kizData;
                                    props.onSelect?.(lot, {type: 'kiz', data: {...kizData}} as ISearchQueryInfo, kizData.decodedBarcode)
                                    break;
                                }
                                case BarcodeType.KizBox: {
                                    const kizBoxData = parsedData.kizBoxData;
                                    props.onSelect?.(lot, {type: 'kizBox', data: {...kizBoxData}} as ISearchQueryInfo, kizBoxData.sscc)
                                    break;
                                }
                                case BarcodeType.kizOsu: {
                                    const kizOsuData = parsedData.kizOsuData;
                                    props.onSelect?.(lot, {type: 'kizOsu', data: {...kizOsuData}} as ISearchQueryInfo, kizOsuData.decodedBarcode)
                                    break;
                                }
                            }
                        })
                    } else {
                        props.onSelect?.(lot)
                    }
                }
                else {
                    props.onSelect?.(lot)
                }
            })
        }
         else {
            //TODO Делаем запрос для получения информации по всем выбранным позициям.
            (async function fetchAndTransform(arr: IEntitySimpleDTO[]) {
                try {
                    const promises = arr.map((lot) =>
                        new Promise<ILotDTO>((resolve) => {
                            ldp.getById(lot.idGlobal, (response) => {
                                resolve(response);
                            });
                        }))

                    const allPromises = await Promise.all(promises);
                    props.onSelect?.(allPromises);
                } catch (error) {
                    console.error("Ошибка", error);
                }
            })(lot);
        }
    }

    return <>
        <GridSelectorInput
            disabled={props.disabled}
            barcodeScan={props.barcodeScan}
            onlyLotRemain={props.onlyLotRemain}
            selectorModalJsx={LotsSelectorModal}
            searchOption={props.searchOption}
            gridFilter={props.gridFilter}
            dispatchGridFilter={props.dispatchGridFilter}
            id={uuidv4()}
            idStoreGlobal={props.idStoreGlobal}
            inline={true}
            label='Поиск партии'
            setScanData={props.setScanData}
            onSelect={(lot, query) => onSelectLot(lot, query)}
            onChange={(e) => props.setScanData?.(e)}
            idTable={props.documentIdTable}
            activateGroupProcessing={props.activateGroupProcessing}
            lastSearchQuerySettings = {props.lastSearchQuerySettings}
            autoFocus={props.autoFocus}
            key={props.key}
        />
    </>
}

export default LotSelectorInput